import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { testConfig } from '../../docs-routes'
import type { CSSProperties } from 'react'

interface Props {
  includeGlobalTexts?: boolean
}

const contentWrapperStyle: CSSProperties = {
  display: 'inline'
}

const globalTexts = ' You can also define global parameters and use them as your custom parameter values.'

const ScriptedTestConfigGlobalParametersIntro = ({
  includeGlobalTexts = true
}: Props) =>
  <Paragraph>
    <span style={contentWrapperStyle}>
      <Color variant='theme-description-text'>
        <span>
          Set custom values for your parameters to override their default values during test runs.{includeGlobalTexts && globalTexts}
          {' '}
          <LinkToDocusaurus path={testConfig}>
            Learn more in the DAI documentation
          </LinkToDocusaurus>
        </span>
      </Color>
    </span>
  </Paragraph>

export default ScriptedTestConfigGlobalParametersIntro
